import React, { Component } from "react";
import {
  Card,
  CardBody,
  CardSubtitle,
  CardTitle,
  Col,
  Container,
  Row,
} from "reactstrap";
import { SuccessButtonLink } from "../common/customButtonLinks";
// TODO: remove relative imports
import pack from "../../package.json";
import { NavigateFunction, useNavigate } from "react-router-dom";
import { LinkButton } from "../components/link-button";


interface HomeProps {
  history: NavigateFunction
}

class Home extends Component<HomeProps> {
  state = {};


  componentDidMount() {
    console.log("Home didMount")
  }

  navigate = (path: string) => {
    console.log(`path: ${path}`, this.props)
    this.props.history(path);
  }

  render() {
    return (
      <React.Fragment>
        <header className="background-home"></header>
        <div className="app flex-row align-items-center">
          <Container className="mt-5">
            <Row className="justify-content-center">
              <Col md="6">
                <Card className="p-4 align-items-center">
                  <CardBody>
                    <CardTitle>
                      <h5>Bem-vindo(a) ao Formulário de Cadastro!</h5>
                    </CardTitle>
                    <CardSubtitle className="text-center">
                      <small>Selecione o método de entrada</small>
                    </CardSubtitle>
                    <Row className="mt-3">
                      {/* TODO: remover botao antigo */}
                      {/* <Col className="text-center">
                        <SuccessButtonLink
                          text="Bolsista"
                          className="text-white btn-block"
                          to="/gerenciamento?role=bolsista"
                          size="lg"
                          block
                        />
                      </Col> */}
                      <LinkButton onClick={() => this.props.history("/gerenciamento?role=bolsista")} text="Bolsistas" />
                    </Row>
                    <Row className="mt-3">
                      {/* <Col className="text-center">
                         <SuccessButtonLink
                          text="Coordenador ou Assistente"
                          className="text-white btn-block"
                          to="/gerenciamento"
                          size="lg"
                          block
                        /> 
                      </Col> */}
                      <LinkButton onClick={() => this.props.history("/gerenciamento")} text="Coordenador ou Assistente" />
                    </Row>
                    <Row className="mt-3">
                      {/* <Col className="text-center">
                         <SuccessButtonLink
                          text="FAEPI"
                          className="text-white btn-block"
                          to="/gerenciamento"
                          size="lg"
                          block
                        /> 
                      </Col> */}
                      <LinkButton onClick={() => this.props.history("/gerenciamento")} text="FAEPI" />
                    </Row>
                    <Row style={{
                      fontSize: '11px',
                      color: '#6d6d6d',
                      justifyContent: 'center',
                      padding: '10px'
                    }}>version: {pack.version}</Row>

                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

// export default Home;
export default (props) => (
  <Home history={useNavigate()} />
);

